import { useCallback, useMemo, useState } from "react";

import ServiceApi from "../services/service.api";
import ContextApp from "../contexts/context.app";
import BasketStorage from "../../ui/views/Basket/Component/BasketStorage";
import ServiceStorage from "../services/service.storage";
import isNil from 'lodash/isNil';

function ProviderApp({ children }) {

  const [isAuth, setIsAuthState] = useState(ServiceApi.hasToken());
  const [userInfo, setUserInfo] = useState(ServiceStorage.getUserInfo());//{name:"",phone:""}
  const [basketInfo, setbasketInfo] = useState(BasketStorage.getBasket());
  const [basketPersonInfo, setbasketPersonInfo] = useState(BasketStorage.getBasketPerson());
  const [lastUpdate, setLastUpdate] = useState();
  const [pageContent, setPageContent] = useState("");
  const [selectedCity, setSelectedCity] = useState(() => {
    return (!isNil(ServiceStorage.getSelectedCity()) ? ServiceStorage.getSelectedCity()
      : {
        "id": 899,
        "name": "کیش",
        "englishName": "kish"
      })
  });



  const setIsAuth = useCallback((value) => {
    if (value) {
      ServiceApi.setToken();
    } else {
      ServiceApi.logout();
    }

    setIsAuthState(value);
  }, [ServiceApi, setIsAuthState]);

  const ctxApp = useMemo(() => ({
    isAuth,
    setIsAuth,
    userInfo,
    setUserInfo,
    basketInfo,
    setbasketInfo,
    basketPersonInfo,
    setbasketPersonInfo,
    lastUpdate,
    setLastUpdate,
    selectedCity,
    setSelectedCity,
    pageContent,
    setPageContent
  }), [
    isAuth,
    setIsAuth,
    userInfo,
    setUserInfo,
    basketInfo,
    setbasketInfo,
    basketPersonInfo,
    setbasketPersonInfo,
    lastUpdate,
    setLastUpdate,
    selectedCity,
    setSelectedCity,
    pageContent,
    setPageContent
  ]);

  return <ContextApp.Provider value={ctxApp}>{children}</ContextApp.Provider>;
}

export default ProviderApp;
